"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderId = exports.PROVIDERS = void 0;
const env_1 = require("../env");
exports.PROVIDERS = {
    das: 2,
    club: 3,
    shitcoins: 4,
    ee: 5,
};
function getProviderId({ providerName }) {
    const forceProvider = (0, env_1.getEnv)("FORCE_PROVIDER");
    if (forceProvider && forceProvider !== 1)
        return forceProvider;
    const maybeProvider = providerName && exports.PROVIDERS[providerName];
    if (maybeProvider)
        return maybeProvider;
    return 1;
}
exports.getProviderId = getProviderId;
//# sourceMappingURL=provider.js.map